module.exports = __webpack_public_path__ + "static/media/50km.1a45ad3b.png";